export enum TaskType {
  Transfer = 'Transfer',
  StockCount = 'StockCount',
  PurchaseOrder = 'PurchaseOrder',
  Order = 'order',
  Retailer = 'retailer',
  OrderCheckout = 'OrderCheckout',
}